import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';
import getCollections from './getCollections';
import { Collection } from '@/types/other';

async function getCollectionsUseQuery(
  context: QueryFunctionContext<QueryKey>
): Promise<Collection[] | null> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [name, query, locale] = context.queryKey as [string, string, string];
  return await getCollections(query, locale);
}

export default getCollectionsUseQuery;
